<template>
  <div>
    <b-overlay variant="light" opacity=".3" blur="2px" :show="show_overlay">
      <div class="text-center">
        <img src="@/assets/logo-azul.png" class="logo-img" />
      </div>
      <h5>Recupera a senha</h5>
      <p class="login-description text-muted mt-2 mb-5">
        Informe seu email para recuperar a senha de acesso à plataforma
      </p>

      <form @submit.prevent="submit()">
        <b-form-group label="E-mail:">
          <b-form-input
            v-model="form.email"
            placeholder="E-mail"
            :state="validateState('email')"
          ></b-form-input>
          <b-form-invalid-feedback>
            <span v-if="!$v.form.email.required"
              >E-mail é um campo obrigatório.</span
            >
            <span v-if="!$v.form.email.email">E-mail inválido</span>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-row class="login-actions">
          <b-col cols="auto" class="mr-auto"
            ><router-link :to="{ name: 'login' }">Voltar </router-link></b-col
          >
          <b-col cols="auto">
            <b-button type="submit" variant="exitos">
              Enviar

              <font-awesome-icon icon="key" />
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data: () => ({
    form: {
      email: "",
    },
    error_message: "",
    show_overlay: false,
  }),
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  computed: {},
  methods: {
    ...mapActions("auth", ["ActionForgotPassword"]),
    async submit() {
      this.show_overlay = true;
      this.error_message = "";
      try {
        await this.ActionForgotPassword(this.form);
        this.$notifications.addNotification({
          message:
            "Você receberá um email com as instruções para recuperar a senha.",
          type: "success",
        });
        this.$router.push({ name: "login" });
      } catch (err) {
        this.$notifications.addNotification({
          message: "Erro ao recuperar senha.",
          type: "danger",
        });
      }
      this.show_overlay = false;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
  created() {},
};
</script>
<style></style>
